import React, { useState, useEffect } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import moment from 'moment';

import { Label } from 'components';
import { ReactComponent as Calendar } from 'assets/icons/calendar.gov.svg';
import { dateFormat, validateDate } from 'utils';
import { validMomentFormat } from 'utils/helpers';

import 'moment/locale/el';
import elGR from 'antd/es/date-picker/locale/el_GR';
//moment.locale('el');

const DatePicker = ({
  label,
  value,
  asterisk,
  allowClear = false,
  ...rest
}) => {
  const [userFocus, setUserFocus] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [width, setWidth] = useState(0);
  // const validFormats = ["M/D/YYYY", "MM/DD/YYYY", moment.ISO_8601]; //accepted formats
  const validFormats = [
    'DD/MM/YYYY',
    'D/M/YYYY',
    'M/D/YYYY',
    'MM/DD/YYYY',
    moment.ISO_8601,
  ];

  const formattedValue = validMomentFormat(value, validFormats);

  useEffect(() => {
    const antPicker = document.querySelector('.ant-picker');
    // if (antPicker !== null) setWidth(antPicker.offsetWidth);
    if (antPicker !== null) setWidth('20%');
  }, []);
  return (
    <>
      <Label label={label} asterisk={asterisk} />
      <AntDatePicker
        {...rest}
        locale={elGR}
        suffixIcon={<Calendar className="ant-calendar-icon" />}
        value={formattedValue}
        //disabledDate={d => !d || d.isAfter('2027-01-01')}
        //disabledDate={d => !d || d.isBefore(new Date((new Date()).valueOf() - 1000*60*60*24)) || d.isAfter('2027-01-01')}
        disabledDate={d => !d}
        format={dateFormat}
        allowClear={allowClear}
        onKeyDown={e => {
          e.preventDefault();
          if (e.key === ' ') {
            // manually open the popover on pressing Space to mimic normal keyboard functions (otherwise in will only open on click)
            e.preventDefault(); // Prevent the page from scrolling on Space
            setOpenPopover(true);
          }
        }}
        open={openPopover}
        onClick={() => setUserFocus(true)} //track user click
        onOpenChange={open => {
          // Only open if it was triggered by an explicit click (avoid automatic open when auto focus from autocomplete, GIG-351)
          if (open && !userFocus) return;
          setOpenPopover(open); // manually control user state
          setUserFocus(false); // Reset after opening
        }}
        popupStyle={{ width }}
      />
      {rest.name &&
        rest.name === 'beneficiaryDate' &&
        validateDate(formattedValue) && (
          <div className="ant-form-item-explain-error">
            Η ημερομηνία πρέπει να είναι παλαιότερη της σημερινής
          </div>
        )}
    </>
  );
};

export default DatePicker;
